import UserIndex from './Index'
import UserForm from './Form'

export default [
  {
    path: '/configuration/users',
    name: 'users',
    component: UserIndex,
    meta: {
      auth: true,
      breadcrumb: 'Users'
    }
  },
  {
    path: '/configuration/users/details/:oid',
    name: 'users.details',
    props: true,
    component: UserForm,
    meta: {
      breadcrumb: 'User Details'
    }
  },
  {
    path: '/profile/:oid',
    name: 'users.profile',
    props: true,
    component: UserForm,
    meta: {
      breadcrumb: 'My profile'
    }
  },
  {
    path: '/configuration/users/add',
    name: 'users.create',
    props: true,
    component: UserForm,
    meta: {
      breadcrumb: 'New user'
    }
  }
]
